/**
 * Real WhatsApp logo as an inline SVG. Replaces the generic
 * `MessageSquare` Lucide icon everywhere we represent WhatsApp.
 *
 * Two variants:
 *   <WhatsAppIcon size={20} />            — uses the brand green `#25D366`
 *   <WhatsAppIcon size={20} mono />       — currentColor (inherits from parent)
 */
export function WhatsAppIcon({ size = 20, mono = false, className = "" }) {
  const fill = mono ? "currentColor" : "#25D366";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <path
        fill={fill}
        d="M16.001 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.246.59 4.45 1.71 6.382L3.2 28.8l6.578-1.671a12.78 12.78 0 0 0 6.222 1.605h.001c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.8-12.8-12.8Zm0 23.36a10.522 10.522 0 0 1-5.359-1.467l-.385-.229-3.91.993 1.044-3.81-.25-.395a10.516 10.516 0 0 1-1.62-5.652c0-5.825 4.74-10.56 10.56-10.56 5.82 0 10.56 4.735 10.56 10.56s-4.74 10.56-10.56 10.56h-.08Z"
      />
      <path
        fill={fill}
        d="M21.776 18.512c-.318-.16-1.881-.928-2.173-1.034-.291-.106-.503-.16-.715.16-.212.32-.82 1.034-1.005 1.246-.185.213-.371.24-.69.08-.317-.16-1.34-.494-2.553-1.575-.943-.84-1.58-1.879-1.766-2.198-.185-.318-.02-.49.14-.65.144-.143.318-.371.477-.557.16-.186.212-.318.318-.531.107-.213.054-.4-.027-.557-.08-.16-.715-1.722-.98-2.358-.258-.62-.52-.535-.715-.546l-.609-.011c-.212 0-.557.08-.847.4-.291.32-1.111 1.087-1.111 2.65 0 1.563 1.137 3.073 1.296 3.286.16.213 2.24 3.42 5.426 4.795.758.327 1.349.522 1.81.668.76.241 1.452.207 1.998.126.61-.091 1.881-.768 2.146-1.51.265-.74.265-1.376.185-1.51-.08-.133-.292-.213-.61-.373Z"
      />
    </svg>
  );
}

export default WhatsAppIcon;
